/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Typography } from '@atoms';
import { SortableArrayField, ColorField, ContentModuleModal, TextField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import useEventColors from '@hooks/useEventColors';

import Form from '../Form';

import Item from './Item';
import AddLink from './AddLink';
import LinkItem from './LinkItem';
import { FORM_FIELD, INITIAL_VALUES } from './constant';

const SocialMediaLinks = ({
  visible = true,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm();
  const eventColors = useEventColors();

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAddLink = (link) => {
    const previousLinks = form.getFieldValue(FORM_FIELD.LINKS.name);
    form.setFieldsValue({ [FORM_FIELD.LINKS.name]: [...previousLinks, link] });
  };

  return (
    <ContentModuleModal
      visible={visible}
      title="Social media links"
      subtitle="Add your social media accounts, to show on the site footer. You can choose up to 8 accounts."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD SOCIAL MEDIA LINKS'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddLink onAdd={handleAddLink} />
      <Form form={form} onFinish={handleSubmit} initialValues={initialValues} layout="vertical">
        <SortableArrayField {...FORM_FIELD.LINKS} form={form} withCount withPlaceholder>
          {(url) => <LinkItem url={url} />}
        </SortableArrayField>
        <Typography.Title level={3} style={{ marginTop: 50 }}>
          Settings
        </Typography.Title>
        <TextField {...FORM_FIELD.TITLE} />
        <ColorField {...FORM_FIELD.BACKGROUND_COLOR} style={NO_MARGIN_BOTTOM} mergeColors={eventColors} />
      </Form>
    </ContentModuleModal>
  );
};

SocialMediaLinks.Item = Item;

export default SocialMediaLinks;
